export default __webpack_public_path__ + "static/media/2024 - GHSI Notice of Annual Stockholders Meeting.bd0448d4.pdf";